export default __webpack_public_path__ + "static/media/icon-upload.bb8a53e1.svg";